import React from "react";
import { IconButton, Paper } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { styled } from "@mui/material/styles";
import WebMAPToolTip from "components/WebMAPToolTip";

import useSnackbar from "../hooks/useSnackbar";

const StyledPaper = styled(Paper)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  minWidth: "unset",
}));

/**
 * @summary Hides all visible layers
 *
 * @param {object} props
 * @returns {object} React
 */
const MapCleaner = React.memo((props) => {
  // Import the clearAllMessages function from the useSnackbar hook.
  // This allows us to clear the Snackbar's state when the button is clicked.
  const { clearSnackbar } = useSnackbar();

  return (
    props.appModel.config.mapConfig.map.mapcleaner && (
      <WebMAPToolTip title="Скрий всички активни слоеве">
        <StyledPaper>
          <StyledIconButton
            aria-label="Изчисти картата"
            onClick={(e) => {
              props.appModel.clear();

              // Call the clearAllMessages function from the useCustomSnackbar hook.
              // This clears the state of messageItems in the Snackbar,
              // ensuring it stays in sync with the actual visibility of the layers.
              clearSnackbar();
            }}
          >
            <VisibilityOffIcon />
          </StyledIconButton>
        </StyledPaper>
      </WebMAPToolTip>
    )
  );
});

export default MapCleaner;
